<ng-container [formGroup]="form">
  <div class="dial-code-select">
    <ng-select
      [items]="filteredDialCodes"
      formControlName="code"
      bindLabel="codeDisplay"
      bindValue="code"
      [selectOnTab]="true"
      [clearable]="false"
      appendTo="body"
      placeholder="Code"
      [required]="required"
      [loading]="isLoading"
      [searchFn]="onSearch"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="d-flex align-items-center">
          <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc"></span>
          <span>
            {{ item.codeDisplay }}
          </span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <div class="d-flex align-items-center">
          <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc" style="min-width: 18px"></span>
          <span class="flex-fill text-truncate">
            {{ item.codeDisplay }}
          </span>
        </div>
      </ng-template>
    </ng-select>
    <div style="margin-top: -15px; font-size: 12px" class="text-danger">
      <div *ngIf="codeCtrl.touched && codeCtrl.hasError('required')">Code is required.</div>
      <div *ngIf="codeCtrl.hasError('code')">Code is required.</div>
    </div>
  </div>
  <mat-form-field class="phone-number">
    <input type="text" formControlName="phone" matInput placeholder="Phone Number" [required]="required" />
    <mat-hint *ngIf="phoneCtrl.hasError('phone')" class="text-danger"> Phone Number is invalid. </mat-hint>
    <mat-error *ngIf="phoneCtrl.touched && phoneCtrl.hasError('required')"> Phone Number is required. </mat-error>
  </mat-form-field>
</ng-container>
